export default __webpack_public_path__ + "assets/brunei-flag.png";